
/**
 * @export
 * @enum {string}
 */
export enum UserStateCriteria {
    LICENSED = 'LICENSED',
    MOBILE = 'MOBILE',
    NO_ACCESS = 'NO_ACCESS',
    DISABLED = 'DISABLED',
    CRM_ONLY = 'CRM_ONLY',
    CREDIT_ALERTS_ONLY = 'CREDIT_ALERTS_ONLY'
}